// Localização: frontend/src/components/Management/EquipamentoFormModal.js (versão 0.0.1)

import React, { useState, useEffect } from 'react';
// 🛑 Modal removido, pois será envolvido pelo Modal.js em EquipamentoPage
// import Modal from '../UI/Modal'; 
import PrimaryButton from '../Common/PrimaryButton';

const STATUS_OPCOES = ['Disponível', 'Em Uso', 'Em Manutenção', 'Descartado'];

/**
 * Formulário para criar ou editar um equipamento (Conteúdo para o Modal.js).
 * @param {function} onClose - Função para fechar o modal.
 * @param {function} onSubmit - Função chamada ao salvar o formulário.
 * @param {object} initialData - Dados iniciais do equipamento (para edição).
 */
// 🛑 Props isOpen e title removidas
const EquipamentoFormContent = ({ onClose, onSubmit, initialData = {} }) => {
    const isEditing = !!initialData.id;
    const [formData, setFormData] = useState({
        nome_equipamento: '',
        marca: '',
        numero_serie: '',
        data_instalacao: '',
        status: 'Disponível',
        data_proxima_manutencao: '',
        descricao: '', 
    });
    const [formError, setFormError] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false); // Novo estado de loading
    const [criarContaPagar, setCriarContaPagar] = useState(false); // Checkbox para criar conta a pagar

    useEffect(() => {
        if (isEditing) {
            // Garante que as datas estejam no formato 'yyyy-mm-dd' para o input type="date"
            setFormData({
                ...initialData,
                data_instalacao: initialData.data_instalacao ? new Date(initialData.data_instalacao).toISOString().substring(0, 10) : '',
                data_proxima_manutencao: initialData.data_proxima_manutencao ? new Date(initialData.data_proxima_manutencao).toISOString().substring(0, 10) : '',
            });
        } else {
            // Reseta para novo
            setFormData({
                nome_equipamento: '',
                marca: '',
                numero_serie: '',
                data_instalacao: '',
                status: 'Disponível',
                data_proxima_manutencao: '',
                descricao: '',
            });
        }
        setFormError(null);
    }, [initialData, isEditing]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        if (type === 'checkbox') {
            setCriarContaPagar(checked);
        } else {
            setFormData(prev => ({ ...prev, [name]: value }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setFormError(null);

        // Validação básica
        if (!formData.nome_equipamento || !formData.numero_serie) {
            setFormError('Nome e Número de Série são campos obrigatórios.');
            return;
        }

        setIsSubmitting(true);
        // Chama a função onSubmit do hook (que faz a chamada API)
        const result = await onSubmit(formData, isEditing, initialData.id);
        setIsSubmitting(false);

        if (result.success) {
            // Se for criação e o checkbox estiver marcado, passar flag e dados do equipamento
            if (!isEditing && criarContaPagar && result.equipamentoId) {
                onClose({ criarContaPagar: true, equipamento: { ...formData, id: result.equipamentoId } });
            } else {
                onClose(); // Fecha o modal normalmente
            }
        } else {
            setFormError(result.message); // Exibe erro da API
        }
    };

    // 🛑 Retorna apenas o conteúdo do formulário (sem o componente Modal)
    return (
        <form onSubmit={handleSubmit} className="space-y-4"> {/* Removido o padding, pois o Modal.js já tem p-6 */}
            
            {formError && (
                <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative text-sm" role="alert">
                    {formError}
                </div>
            )}

            {/* Linha 1: Nome e Marca */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                    <label htmlFor="nome_equipamento" className="block text-sm font-medium text-gray-700">Nome do Equipamento <span className="text-red-500">*</span></label>
                    <input
                        type="text"
                        name="nome_equipamento"
                        id="nome_equipamento"
                        value={formData.nome_equipamento}
                        onChange={handleChange}
                        required
                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-emerald-500 focus:ring-emerald-500 sm:text-sm"
                    />
                </div>
                <div>
                    <label htmlFor="marca" className="block text-sm font-medium text-gray-700">Marca</label>
                    <input
                        type="text"
                        name="marca"
                        id="marca"
                        value={formData.marca}
                        onChange={handleChange}
                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-emerald-500 focus:ring-emerald-500 sm:text-sm"
                    />
                </div>
            </div>

            {/* Linha 2: Número de Série e Status */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                    <label htmlFor="numero_serie" className="block text-sm font-medium text-gray-700">Número de Série <span className="text-red-500">*</span></label>
                    <input
                        type="text"
                        name="numero_serie"
                        id="numero_serie"
                        value={formData.numero_serie}
                        onChange={handleChange}
                        required
                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-emerald-500 focus:ring-emerald-500 sm:text-sm"
                    />
                </div>
                <div>
                    <label htmlFor="status" className="block text-sm font-medium text-gray-700">Status</label>
                    <select
                        name="status"
                        id="status"
                        value={formData.status}
                        onChange={handleChange}
                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-emerald-500 focus:ring-emerald-500 sm:text-sm"
                    >
                        {STATUS_OPCOES.map(status => (
                            <option key={status} value={status}>{status}</option>
                        ))}
                    </select>
                </div>
            </div>

            {/* Linha 3: Datas */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                    <label htmlFor="data_instalacao" className="block text-sm font-medium text-gray-700">Data de Instalação</label>
                    <input
                        type="date"
                        name="data_instalacao"
                        id="data_instalacao"
                        value={formData.data_instalacao}
                        onChange={handleChange}
                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-emerald-500 focus:ring-emerald-500 sm:text-sm"
                    />
                </div>
                <div>
                    <label htmlFor="data_proxima_manutencao" className="block text-sm font-medium text-gray-700">Próxima Manutenção</label>
                    <input
                        type="date"
                        name="data_proxima_manutencao"
                        id="data_proxima_manutencao"
                        value={formData.data_proxima_manutencao}
                        onChange={handleChange}
                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-emerald-500 focus:ring-emerald-500 sm:text-sm"
                    />
                </div>
            </div>

            {/* Descrição */}
            <div>
                <label htmlFor="descricao" className="block text-sm font-medium text-gray-700">Descrição/Observações</label>
                <textarea
                    name="descricao"
                    id="descricao"
                    rows="2"
                    value={formData.descricao}
                    onChange={handleChange}
                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-emerald-500 focus:ring-emerald-500 sm:text-sm"
                />
            </div>

            {/* Checkbox para criar conta a pagar (apenas ao criar novo equipamento) */}
            {!isEditing && (
                <div className="flex items-center gap-3 p-4 bg-emerald-50 border border-emerald-200 rounded-lg">
                    <input
                        type="checkbox"
                        id="criarContaPagar"
                        name="criarContaPagar"
                        checked={criarContaPagar}
                        onChange={handleChange}
                        className="w-4 h-4 text-emerald-600 border-gray-300 rounded focus:ring-emerald-500"
                    />
                    <label htmlFor="criarContaPagar" className="text-sm font-medium text-gray-700 cursor-pointer">
                        Criar conta a pagar referente ao Equipamento
                    </label>
                </div>
            )}

            <div className="pt-4 border-t mt-4 flex justify-end">
                <PrimaryButton type="submit" disabled={isSubmitting}>
                    {isSubmitting ? 'Salvando...' : (isEditing ? "Salvar Alterações" : "Criar Equipamento")}
                </PrimaryButton>
            </div>
        </form>
    );
};

export default EquipamentoFormContent; // Renomeado para refletir o novo propósito